import React, { useState } from "react";
import Innerhtml from "../utils/Innerhtml";
import WsrvImage from "../utils/WsrvImage";

export default function ClcGuide({ data }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <section className="pt-20 ">
        <div
          className="clcguid py-6"
    style={{
  background: "linear-gradient(to bottom, white 50%, #FFD338 50%)",
}}

          
        >
          <div className="container">
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-14 xl:gap-4 relative">
              {data?.media && (
                <div className="md:block hidden">
                  <WsrvImage
                    src={data?.media}
                    alt={data.heading?.split("||")[0] || "CLC Guide"}
                    width={600}
                    height={500}
                    widths={[320, 480, 600, 800]}
                    sizes="(max-width: 1024px) 100vw, 600px"
                    className="w-full h-full object-contain mt-[24px]"
                  />
                </div>
              )}

              <div className="xl:mt-20 mt-16">
                {data?.heading && (
                  <h2 className="text-5xl md:text-5xl md:text-start text-center font-bold text-black  lg:mb-20 my-4 mb-10">
                    {data.heading.split("||")[0]}
                    {/* <br /> */}
                    {data.heading.split("||")[1] && (
                      <span className="block mt-2">
                        {data.heading.split("||")[1]}
                      </span>
                    )}
                  </h2>
                )}

                {data?.media && (
                  <div className="md:hidden">
                    <WsrvImage
                      src={data.media}
                      alt={data.heading?.split("||")[0] || "CLC Guide"}
                      width={400}
                      height={350}
                      widths={[320, 480, 600]}
                      sizes="100vw"
                      className="w-full h-full object-contain"
                    />
                  </div>
                )}

                {data?.content && (
                  <div>
                    <div className="relative mb-4">
                      <div className="text-black  leading-9 md:leading-[46px] font-[600] mt-[134px] ">
                        <Innerhtml
                          lineClamp="line-clamp-6"
                          data={data?.content}
                        />
                      </div>

                      <span
                        onClick={() => setOpen(true)}
                        className="absolute -bottom-4 xl:-bottom-6 right-0 text-[#1C4075] rounded-xl px-2 py-1 text-base cursor-pointer font-semibold"
                      >
                        Read more
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {open && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 "
          onClick={() => setOpen(false)}
        >
          <div
            className="bg-white p-6 rounded-2xl max-w-6xl w-full shadow-lg relative max-h-[600px] overflow-scroll"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-black"
            >
              ✕
            </button>

            {/* Full text */}
            <div className="text-black text-lg leading-[42px] font-medium">
              {/* {data?.content} */}
              <Innerhtml data={data?.content} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
